import { memo } from 'react';
import { useSelector } from 'react-redux';

import { type AssetCustomFieldValue } from '@air/api/types';

import { useCurrentClipPermissions } from '~/components/PrivateAssetModal/hooks/useCurrentClipPermissions';
import { centralizedClipAssetIdSelector } from '~/store/centralizedClip/selectors';
import { canChangeAssetCustomFields } from '~/utils/permissions/assetPermissions';
import { PrivateAssetCustomFieldDateInput } from './PrivateAssetCustomFieldDateInput';
import { PrivateAssetPanelCustomFieldContainer } from './PrivateAssetPanelCustomFieldContainer';

export type PrivateAssetPanelCustomFieldDateInputProps = {
  field: AssetCustomFieldValue;
};

export const PrivateAssetPanelCustomFieldDateInput = memo(({ field }: PrivateAssetPanelCustomFieldDateInputProps) => {
  const assetId = useSelector(centralizedClipAssetIdSelector);
  const { clipPermissions } = useCurrentClipPermissions();
  const canEditCustomFields = canChangeAssetCustomFields(clipPermissions);

  return (
    <PrivateAssetPanelCustomFieldContainer field={field}>
      <PrivateAssetCustomFieldDateInput
        assetId={assetId}
        canEditCustomFields={canEditCustomFields}
        field={field}
        trackingLocation="asset-details"
      />
    </PrivateAssetPanelCustomFieldContainer>
  );
});

PrivateAssetPanelCustomFieldDateInput.displayName = 'PrivateAssetPanelCustomFieldDateInput';
